import React, { useContext, useState } from 'react';
import { Row, Col, CardBody, Card, Container, CardTitle  } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { faFileAlt, faUpload, faCalendarAlt, faUser, faComments, faStairs } from '@fortawesome/free-solid-svg-icons';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import Skeleton from 'react-loading-skeleton';
import DashboardCards from 'components/common/DashboardCards';
import AssistantWelcomeCard from 'components/assistant/AssistantWelcomeCard';

function SavvySpeak() {
    const { t } = useTranslation();
    const { userId } = useContext(UserSettingsContext);
    const { userSettings } = useContext(UserSettingsContext)
    if(!userId){
        return <Card><CardBody><Skeleton height={40} count={5} /></CardBody></Card>
    }

    const cards = [
        {
            title: 'savvySpeak.dashboardCards.exercise.title',
            text: 'savvySpeak.dashboardCards.exercise.text',
            icon: faComments,
            type: 'linkExtern',
            link: `/chat/${userSettings.analyze_all_contacts}`
        },
        {
            title: 'savvySpeak.dashboardCards.progress.title',
            text: 'savvySpeak.dashboardCards.progress.text',
            icon: faStairs,
            link: '/admin/profile'
        },
        {
            title: 'savvySpeak.dashboardCards.profile.title',
            text: 'savvySpeak.dashboardCards.profile.text',
            icon: faUser,
            link: '/admin/profile'
        },
    ];
    return (
        <Card className="card-tasks" style={{ height: "auto", marginLeft: "10px", borderRadius: '0.875rem', overflow: 'hidden' }}>
            <CardBody>
                <h3 className="title">{t('savvySpeak.title')}</h3>
                <Row className="align-items-center">
                    <Col xs="12" xl="6" className="order-1 order-xl-2">
                        <AssistantWelcomeCard welcomeMsg={t('savvySpeak.welcomeMessage')} />
                    </Col>
                    <Col lg="12" xl="6" className="order-2 order-xl-1">
                        <Container className="my-4">
                            <DashboardCards cards={cards.filter(card => (card.role || userId.tenant_role) === userId.tenant_role)} />
                        </Container>        
                    </Col>
                </Row>  
                
            </CardBody>
        </Card>)
}

export default SavvySpeak;